<template>
  <router-view />
</template>
  <script>
import { reactive, provide, onMounted, watch, ref, computed } from "vue"
import Language from "@/hooks/language.js"
import Router from "@/hooks/router.js"
import bridge from "@/utils/sdkBridge.js"
import * as request from "@/api/request"
import * as utils from "@/utils"
import * as _ from "lodash"

export default {
  components: {},
  setup() {
    const routerData = {}
    const compData = {}
    const pageData = reactive({
      isLogin: false,
      host: utils.getMainHost(),
      pageId: "zz_dlssrvn1",
      isDownloadExe: true,
      abTestVersion: "",
      gameId: 274,
    })
    provide("pageData", pageData)

    if (pageData.gameId !== void 0) {
      pageData.gameId =
        utils.getUrlParams("gameId") ||
        utils.getUrlParams("gameID") ||
        utils.getUrlParams("game_id") ||
        pageData.gameId
    }

    const { initLang, curLang, getLangTxt, langData } = Language()
    initLang()
    // 自定义setup - 开始
    pageData.gameId =
      utils.getUrlParams("gameId") ||
      utils.getUrlParams("gameID") ||
      utils.getUrlParams("game_id") ||
      pageData.gameId
    pageData.isDownloadExe = false

    const country = ref("")

    const getIpInfo = async () => {
      let res = await request.getJSON("//gstore.endomainname.com/test_ip")
      return res
    }

    const zzyPoint = async (eventName) => {
      let mainHost = window.location.hostname.split(".")[1]

      let ipRes = null
      if (!country.value) {
        ipRes = await getIpInfo()
        if (ipRes.result == 1) {
          country.value = ipRes.data.info[0]
        }
      }

      let fingerPrint = await utils.getFingerPrint(ipRes && ipRes.data)

      const deviceInfoOld = utils.getDeviceOld()

      const systemInfo =
        deviceInfoOld.isAndroid() || deviceInfoOld.isWinPhone()
          ? "android"
          : deviceInfoOld.isIOS() || deviceInfoOld.isIpad()
          ? "ios"
          : "pc"

      const deviceInfo = deviceInfoOld.isPhone() ? "mobile" : "pc"

      await request.getJSON(
        "//datain.octlib.com/api/v1/hw/common/event/collect",
        {
          apikey: "72e0e1c0-51e3-45ab-9b36-bf3b82143d9d",
          id: 14,
          gameID: pageData.gameId,
          deviceCode: deviceInfo,
          deviceFrom: systemInfo,
          ext1: pageData.pageId,
          ext2: encodeURIComponent(window.location.href),
          ext3: pageData.gameId,
          ext4: utils.getUrlParams("cid"),
          ext5: utils.getUrlParams("scid"),
          ext6: utils.getUrlParams("zone"),
          ext7: new Date().getTime(),
          ext8: eventName || "",
          ext9: fingerPrint,
          ext10: systemInfo,
          ext11: mainHost == "gm99" ? "gm" : "global",
          ext12: mainHost,
          ext13: country.value,
          ext14: utils.getSystemLanguage(),
          ext15: utils.getUrlParams("adid"),
          ext16: utils.getUrlParams("camid"),
          ext17: utils.getUrlParams("camname"),
          ext18: utils.getUrlParams("adsetid"),
          ext19: utils.getUrlParams("adsetname"),
          ext20: utils.getUrlParams("adname"),
        }
      )
    }
    provide("zzyPoint", zzyPoint)
    zzyPoint()

    const gaClickUpload = (event) => {
      try {
        window.dataLayer.push({
          event,
          aid: pageData.pageId,
          ab_test_version: pageData.abTestVersion,
          device: utils.systemType(),
        })
      } catch (e) {}
    }

    provide("gaClickUpload", gaClickUpload)

    watch(
      () => pageData.abTestVersion,
      (value) => {
        if (value) {
          gaClickUpload("gtm-visit")
        }
      }
    )

    // 自定义setup - 结束
    return { pageData, langData }
  },
}
</script>
  <style lang="scss">
@import "assets/common.scss";
#app {
  height: 100%;
  width: 100%;
}
</style>
  